<template>
  <div class="view-container">
    <view-header> Attendance </view-header>
    <el-row style="padding: 16px; height: calc(100% - 56px)">
      <el-col :span="8" style="padding-right: 16px">
        <el-form
          ref="form"
          :model="form"
          :rules="formRules"
          label-position="top"
        >
          <el-form-item label="Attendance Listening" prop="status">
            <el-switch v-model="form.status" />
          </el-form-item>
          <template v-if="form.status">
            <el-form-item label="URL" prop="url">
              <el-input v-model="form.url"></el-input>
            </el-form-item>
            <el-form-item label="HTTP Basic Auth" prop="auth">
              <el-switch v-model="form.auth" />
            </el-form-item>
            <template v-if="form.auth">
              <el-form-item label="Login" prop="login">
                <el-input v-model="form.login"></el-input>
              </el-form-item>
              <el-form-item label="Password" prop="password">
                <el-input v-model="form.password" show-password></el-input>
              </el-form-item>
            </template>
          </template>
        </el-form>
        <el-button type="success" @click="onSave">Save</el-button>
      </el-col>
      <el-col :span="16" style="height: 100%">
        <logger topic="attendance"></logger>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import ViewHeader from "@/components/ViewHeader";
import Logger from "@/components/Logger";
export default {
  name: "Attendance",
  components: { Logger, ViewHeader },
  data() {
    const validateUrl = (rule, value, callback) => {
      if (this.form.status && !value) {
        callback(new Error("URL is required field"));
      } else {
        callback();
      }
    };
    const validateLoginPassword = (rule, value, callback) => {
      if (this.form.auth && !value) {
        callback(new Error("Login and password are required fields"));
      } else {
        callback();
      }
    };
    return {
      form: {
        status: false,
        url: null,
        auth: false,
        login: null,
        password: null,
      },
      formRules: {
        url: [
          {
            validator: validateUrl,
            trigger: "change",
          },
        ],
        login: [
          {
            validator: validateLoginPassword,
            trigger: "change",
          },
        ],
        password: [
          {
            validator: validateLoginPassword,
            trigger: "change",
          },
        ],
      },
    };
  },
  methods: {
    reload() {
      const loader = this.$loading({
        lock: true,
      });
      this.$network
        .get("attendance")
        .then(({ data }) => {
          this.form.status = data.isListeningOn;
          this.form.url = data.url;
          this.form.auth = data.isHttpBasicEnabled;
          this.form.login = data.login;
          this.form.password = data.password;
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Loading failed",
          });
        })
        .finally(() => {
          loader.close();
        });
    },
    onSave() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          const data = {
            isListeningOn: this.form.status,
          };
          if (this.form.status) {
            data.url = this.form.url;
            data.isHttpBasicEnabled = this.form.auth;
            if (this.form.auth) {
              data.login = this.form.login;
              data.password = this.form.password;
            }
          }
          const loader = this.$loading({
            lock: true,
          });
          this.$network
            .post("attendance", data)
            .then(() => {
              this.$message({
                type: "success",
                message: "Successfully saved!!!",
              });
              this.reload();
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "Loading failed",
              });
            })
            .finally(() => {
              loader.close();
            });
        }
      });
    },
  },
  mounted() {
    this.reload();
  },
};
</script>

<style lang="scss" scoped></style>
